import { useMutation } from '@tanstack/react-query'
import { createBatch } from '../../services'
import { BatchesMutationKeys } from '@/modules/batches/keys'
import { CreateBatchRequest, CreateBatchResponse } from '@/modules/batches/type'
import { UseBaseMutationOptions } from '@/core/api/type'

export default function useMutationCreateBatch(
	props?: UseBaseMutationOptions<CreateBatchResponse, CreateBatchRequest>,
) {
	return useMutation({
		mutationKey: [BatchesMutationKeys.CreateBatch],
		mutationFn: createBatch,
		...props,
	})
}
